import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../petInfoAction';
import fetchApi from "./fetchApi";

function fetchPetInfoAction() {
  return fetchApi('/v1/fc_api/pet_info_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchPetInfoAction;
